import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import useSWR from 'swr';
import { RedocStandalone } from 'redoc';

import useUserData from '../util/hooks/useUserData'
import PageLoader from '../Common/PageLoader';
import ErrorMessage from '../Common/ErrorMessage';

const defaultTitle = document.title;

const RedocWrapper = styled.div`
	background-color: #FFF;
`;

export default () => {

	const { versionSlug, serviceCode } = useParams();

	const { isLoading, isDev } = useUserData();

	const basePath = isDev ? 'private' : 'versions';

	const { data, error } = useSWR(isLoading ? null : `/${basePath}/${versionSlug}/services/openapi/${serviceCode}.json`);

	useEffect(() => {
		if(!data) {
			const newTitle = `${defaultTitle} | ${serviceCode[0].toUpperCase()}${serviceCode.substr(1).replace(/-/g, ' ')}`;
			if(document.title !== newTitle)
				document.title = newTitle;
		}

		if(data) {
			const newTitle = `${defaultTitle} | ${data.info.title}`;
			if(document.title !== newTitle)
				document.title = newTitle;
		}

		return () => document.title = defaultTitle;

	}, [data, serviceCode]);

	if(error) {
		return (
			<ErrorMessage>{error.message}</ErrorMessage>
		);
	}

	const formatLastUpdateDate = lastUpdate => new Date(lastUpdate).toLocaleString();

	const formatDescription = schemaInfoProperty => {

		if(!schemaInfoProperty.lastUpdate)
			return schemaInfoProperty.description;

		return `${schemaInfoProperty.description}\n\n **Last update**: ${formatLastUpdateDate(schemaInfoProperty.lastUpdate)}`;
	}

	if(data) {

		const extensions = ['x-janis-permissions'];

		if(isDev) {
			extensions.unshift('x-janis-namespace','x-janis-method');
		}

		const environmentName = process.env.REACT_APP_ENVIRONMENT_NAME ? process.env.REACT_APP_ENVIRONMENT_NAME.toLowerCase() : false;
		const currentServer = data.servers.find(server => environmentName && server.variables.environment.default === environmentName ? server : false);

		const schemaSpecification = {
			...data,
			info: {
				...data.info,
				description: formatDescription(data.info)
			},
			servers: currentServer ? [currentServer] : data.servers
		}

		return (
			<RedocWrapper>
				<RedocStandalone
					spec={schemaSpecification}
					options={{
						nativeScrollbars: true,
						pathInMiddlePanel: true,
						requiredPropsFirst: true,
						sortTagsAlphabetically: true,
						sortOperationsAlphabetically: true,
						sortPropsAlphabetically: true,
						scrollYOffset: 70,
						showExtensions: extensions,
						theme: {
							colors: {
								primary: {
									main: '#2b77fb'
								}
							}
						}
					}}
				/>
			</RedocWrapper>
		);
	}

	return <PageLoader/>;
};
